/** True for localized values stored as { de: ..., en: ... } */
export const isLocalized = (value) => !!value && typeof value === 'object' && !Array.isArray(value);

/** Read the text for one language from either a plain string or a localized object. */
export const getLocalizedText = (value, lang) => (isLocalized(value) ? value[lang] || '' : value || '');

/** Write the text for one language while preserving the original storage shape. */
export const setLocalizedText = (value, lang, text) => {
  const base = isLocalized(value) ? value : { de: value ?? '', en: value ?? '' };
  return { ...base, [lang]: text };
};
